import { useThree, useFrame } from "@react-three/fiber"
import { useEffect, useRef } from "react"
import * as THREE from "three"
import { useAudioStore } from "../store/useAudioStore"
import { audioBus } from "./audioRegistry"

export default function ActiveAudio() {
  const { camera } = useThree()
  const ctxRef = useRef(null)

  const fadeRef = useRef(null)
  const pendingStopAllRef = useRef(false)

  const fadeTo = (to, dur = 0.4) => {
    const ctx = ctxRef.current
    if (!ctx) return
    fadeRef.current = {
      from: useAudioStore.getState().master,
      to,
      start: ctx.currentTime,
      dur,
    }
  }

  useEffect(() => {
    const listener = camera.getObjectByName("AudioListener")
    if (!listener) return
    ctxRef.current = listener.context

    const hardDisableNow = () => {
      const ctx = ctxRef.current
      const { enabled } = useAudioStore.getState()
      if (!enabled) return

      // coupe tout tout de suite (pas de fade, car rAF peut être gelé)
      fadeRef.current = null
      pendingStopAllRef.current = false
      useAudioStore.getState().setMaster(0)
      audioBus.stopAll()
      useAudioStore.getState().setEnabled(false)
      try { ctx?.suspend?.() } catch { }
    }

    const onVisibility = () => {
      if (document.hidden) hardDisableNow()
    }

    const onPageHide = () => {
      hardDisableNow()
    }

    document.addEventListener("visibilitychange", onVisibility)
    window.addEventListener("pagehide", onPageHide)


    window.__audioToggle = async () => {
      const { enabled } = useAudioStore.getState()
      if (!enabled) {
        useAudioStore.getState().setEnabled(true)
        try { await ctxRef.current?.resume?.() } catch { }
        useAudioStore.getState().setMaster(0)
        pendingStopAllRef.current = false
        fadeTo(1, 0.4)
      } else {
        pendingStopAllRef.current = true
        fadeTo(0, 0.35)
      }
    }

    return () => {
      document.removeEventListener("visibilitychange", onVisibility)
      window.removeEventListener("pagehide", onPageHide)
      delete window.__audioToggle
      ctxRef.current = null
    }
  }, [camera])

  useFrame(() => {
    const ctx = ctxRef.current
    if (!ctx) return

    const a = fadeRef.current
    if (!a) return

    const t = (ctx.currentTime - a.start) / a.dur
    let next = a.to

    if (t <= 0) next = a.from
    else if (t >= 1) {
      next = a.to
      fadeRef.current = null
    } else {
      next = THREE.MathUtils.lerp(a.from, a.to, t)
    }

    useAudioStore.getState().setMaster(next)

    if (!fadeRef.current && pendingStopAllRef.current && next <= 0.0005) {
      audioBus.stopAll()
      useAudioStore.getState().setEnabled(false)
      pendingStopAllRef.current = false
      try { ctx?.suspend?.() } catch { }
    }
  })

  return null
}